import React, { useState, useEffect } from 'react'
import { Typography } from 'cgi-ui-components'
import { makeStyles } from '@mui/styles'
import EditorLowerRightPanel from './EditorLowerRightPanel'
import EditorUpperRightPanel from './EditorUpperRightPanel'
import EditorLeftPanel from './EditorLeftPanel'
import { connect } from 'react-redux'
import { MAX_FAV_LIMIT_MESSAGE } from '../../constants/displayMessages'

import {
  fetchLibraryList,
  fetchLibraryMetadata,
  updateSrcMaterial,
  updateSelectedColor,
  updateFavouritesLibrary,
} from '../../store/materialEditor/actionCreator'
import { showNotification } from '../../store/notification/actionCreator'

const useStyles = makeStyles((theme) => ({
  root: {
    height: `calc(100vh - 315px)`,
  },
  spacing: {
    margin: '3px 0px 5px',
    padding: '0px 8px',
  },
  editor: { display: 'flex', flexDirection: 'column', height: '100%' },
  content: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
  },
  contentMain: { flexGrow: 1, overflow: 'hidden' },
  rightSection: { width: 0, flexGrow: 1 },
  rightContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
  },
}))

const ColorEditor = ({
  activeOperations,
  variant,
  fetchLibraryList,
  libraryList,
  srcMaterialList,
  selectedLibrary,
  updateSrcMaterial = () => {},
  fetchLibraryMetadata = () => {},
  favouriteId = '',
  favouriteList = [],
  selectedColor = '#FFFFFF',
  updateSelectedColor = () => {},
  selectedLibraryName = '',
  updateFavouritesLibrary = () => {},
  enableActions = () => {},
  showNotification,
  isLoadingLibDetails,
  isLoadingMaterialList = false,
}) => {
  const classes = useStyles()

  const [showRightSection, setShowRightSection] = useState(false)

  //API call to get all material swatch list for colors and libraryList

  useEffect(() => {
    fetchLibraryList(variant)
  }, [fetchLibraryList, variant])

  useEffect(() => {
    if (favouriteId !== '') {
      fetchLibraryMetadata(favouriteId, variant, true)
    }
  }, [favouriteId, variant, fetchLibraryMetadata])

  useEffect(() => {
    let isSelected = srcMaterialList.filter((item) => item.selected)
    setShowRightSection(Boolean(isSelected.length))
  }, [srcMaterialList])

  const handleLibraryChange = (value) => {
    fetchLibraryMetadata(value, variant)
  }

  const handleSwatchButtonClick = (value, data) => {
    updateSelectedColor(value.toUpperCase())
  }

  const handleReplace = () => {
    const srcListForUpdate = srcMaterialList
      .filter((item) => item.selected)
      .map((item) => ({
        ...item,
        color: selectedColor,
        swatch_thumbnail_url: null,
        updated: true,
      }))

    updateSrcMaterial(srcListForUpdate)
    enableActions()
  }
  const handleFavsUpdate = ({ list, action, color }) => {
    let newList = []

    if (action === 'add') {
      let listCpy = [...favouriteList]
      newList = [{ color_hexcode: color }, ...listCpy]
    }
    if (action === 'delete') {
      let listCpy = [...favouriteList]
      newList = listCpy.filter((item) => item.color_hexcode !== color)
    }
    updateFavouritesLibrary({
      isFavLibSelected: selectedLibraryName === 'Favourites',
      list: newList,
      listId: favouriteId,
      type: 'color',
    })
  }

  const handleError = (error) => {
    if (error === 'max-limit-error') {
      showNotification(true, MAX_FAV_LIMIT_MESSAGE, 'error')
    }
  }

  const onColorPickerChange = (value) => {
    updateSelectedColor(value.toUpperCase())
  }

  return (
    <div className={classes.root}>
      <div className={classes.editor}>
        <div className={classes.spacing}>
          <Typography
            variant="subtitle2"
            label={`Edit ${variant} for selected asset (${activeOperations?.value?.name})`}
          />
        </div>

        <div className={classes.contentMain}>
          <div className={classes.content}>
            <EditorLeftPanel
              variant={variant}
              srcMaterialList={srcMaterialList}
              onMaterialSelected={updateSrcMaterial}
              isLoadingMaterialList={isLoadingMaterialList}
            />
            <div className={classes.rightSection}>
              {showRightSection && (
                <div className={classes.rightContent}>
                  <EditorUpperRightPanel
                    variant={variant}
                    selected={selectedColor}
                    favouriteList={favouriteList}
                    handleFavsUpdate={(list) => handleFavsUpdate(list)}
                    handleError={(error) => handleError(error)}
                    onColorPickerChange={onColorPickerChange}
                  />
                  <EditorLowerRightPanel
                    variant={variant}
                    libraryList={libraryList}
                    selectedLibrary={selectedLibrary}
                    handleLibraryChange={(data) => handleLibraryChange(data)}
                    handleSwatchButtonClick={(value, data) =>
                      handleSwatchButtonClick(value, data)
                    }
                    selected={selectedColor}
                    handleReplace={handleReplace}
                    isLoadingLibDetails={isLoadingLibDetails}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ({
  materialEditor: {
    srcMaterialList,
    libraryList,
    selectedLibrary,
    favouriteId,
    favouriteList,
    selectedColor,
    selectedLibrary: { library_name: selectedLibraryName },
    isLoadingLibDetails,
    isLoadingMaterialList,
  },
}) => ({
  srcMaterialList,
  libraryList,
  selectedLibrary,
  favouriteId,
  favouriteList,
  selectedColor,
  selectedLibraryName,
  isLoadingLibDetails,
  isLoadingMaterialList,
})
export default connect(mapStateToProps, {
  fetchLibraryList,
  updateSrcMaterial,
  fetchLibraryMetadata,
  updateSelectedColor,
  updateFavouritesLibrary,
  showNotification,
})(ColorEditor)
